export function setCookie(name, value, days = 365) {
    // only run in browser
    if (typeof document === "undefined") return;

    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie = `${name}=${encodeURIComponent(
        value
    )};${expires};path=/;SameSite=Lax`;
}

export function getCookie(name) {
    if (typeof document === "undefined") return null;

    const cname = name + "=";
    const decoded = decodeURIComponent(document.cookie || "");
    const ca = decoded.split(";");
    for (let c of ca) {
        while (c.charAt(0) === " ") c = c.substring(1);
        if (c.indexOf(cname) === 0) return c.substring(cname.length, c.length);
    }
    return null;
}